import React, { forwardRef, useImperativeHandle, useRef } from "react";
import classNames from "classnames";
import { nanoid } from "nanoid";
import { FiSearch } from "react-icons/fi";
import "./style.scss";

interface Props {
  label?: string;
  type?: "text" | "password" | "email" | "number" | "phone";
  className?: string;
  maxLength?: number;
  placeholder?: string;
  isRequired?: boolean;
  disabled?: boolean;
  value?: string;
  autoFocus?: boolean;
  onBlur?(): void;
  onChange?(param: string): void;
}

export const SearchInput = forwardRef(
  (
    {
      className,
      type = "text",
      placeholder,
      maxLength,
      disabled = false,
      value = "",
      isRequired,
      onBlur = () => {},
      onChange = () => {},
    }: Props,
    ref,
  ) => {
    const inputRef = useRef<HTMLInputElement>(null);

    useImperativeHandle(ref, () => ({
      focus() {
        inputRef.current && inputRef.current.focus();
      },
    }));

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      let value = event.target.value || "";
      if (type === "number") {
        value = value.replace(/[^[\\./d]]/g, "");
      }
      onChange(maxLength ? value.slice(0, maxLength) : value);
    };
    const id = nanoid();
    return (
      <div className={classNames("search-input", className)}>
        <FiSearch color="#1B1B1B" size={18} className="search-input__icon" />
        <input
          value={value || ""}
          id={id}
          onChange={handleChange}
          onBlur={onBlur}
          placeholder={placeholder}
          type={type}
          autoComplete={"new-password"}
          disabled={disabled}
          ref={inputRef}
          className={classNames({
            active: value,
          })}
          required={isRequired}
        />
      </div>
    );
  },
);
